<template>
  <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
      <!--begin::Title-->
      <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t('breadcrumbs.shop.shops') }}</h1>
      <!--end::Title-->
      <!--begin::Separator-->
      <span class="h-20px border-gray-300 border-start mx-4"></span>
      <!--end::Separator-->
      <!--begin::Breadcrumb-->

      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">

        <li class="breadcrumb-item text-muted">
          <router-link  :to="'/admin/shops'" class="text-muted text-hover-primary">{{  $t('breadcrumbs.shop.shops') }}</router-link>
          <span class="bullet bg-gray-200 w-5px h-2px m-2"></span>
        </li>
        <li  class="breadcrumb-item text-dark">{{ $t('breadcrumbs.shop.managment') }}</li>
      </ul>
    </div>
    <div class="d-flex align-items-center gap-2 gap-lg-3">
      <div class="m-0">
        <button @click="$goBack" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder">
          <span class="svg-icon svg-icon-md">
              <i class="fas fa-backspace"></i>
          </span>{{$t("back")}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { required : true , type: String, default: 'Boutique' },
    breadcrumbs: { required : false , type: Array, default: [] },
    back: { required : false , type: Boolean, default: false },
  },

  methods: {
    openCreateModal(){
      $('#createModal').modal('toggle')
    },
  }

}
</script>
